<template>
  <div style="color:black;background-color:white;">
    <div class="install_card" style="overflow:hidden;"
       v-if="success == null">
     <b-row style="justify-content:center;">
     <b-col style="max-width:35rem;">
       <div style="text-align:center;margin-bottom:2rem;">
         <img style="height:fit-context;width:60%;"
           src="../../public/images/logo2.svg">
         </img>
       </div>
       <div style="max-width:60%;margin:auto;">
         <div class="install-text"
           style="margin-top:1rem;text-align:center;">
           VideoCafe is a web application for video collaboration that
           makes real-time visual communication faster, easier and richer.
         </div>
       </div>
       <div style="text-align:left;font-size:0.75rem;max-width:80%;margin: 2rem auto 0 auto;">
          <span>
            If you want to associate your Slack workspace with
            a custom VCafe account you can enter it below.
          </span>
          <span style="font-style:italic;">
            In most cases just leave the Account input box empty.
          </span>
       </div>
       <div style="text-align:center;max-width:80%;margin:auto;">
          <b-input size="sm"
           placeholder="videocafe.live account (optional)"
           v-on:keyup="account_error=false"
           v-model="account"
          > </b-input>
          <div v-if="account && !account_error"
            style="margin: 0 0.5rem;font-size:0.75rem;">
            You must be an administrator of the VCafe account you
            specify and both your Slack workspace and your VCafe account
            must be associated with the same email address.
          </div>
          <div v-if="account && account_error"
            style="font-size: 0.9rem; font-style:bold; color: red;">
            Please enter a valid VCafe account.
          </div>
       </div>
       <div style="text-align:center;font-size:0.75rem;max-width:80%;margin: 2rem auto 0 auto;">
         <span> Click to read our </span>
         <a href="https://videocafe.live/privacy.html" target="_blank">Privacy Policy</a>
       </div>
       <div style="margin: 2rem 0;text-align: center"">
           <div @click="install" class="slack_btn"><svg xmlns="http://www.w3.org/2000/svg" style="height:20px;width:20px;margin-right:12px" viewBox="0 0 122.8 122.8"><path d="M25.8 77.6c0 7.1-5.8 12.9-12.9 12.9S0 84.7 0 77.6s5.8-12.9 12.9-12.9h12.9v12.9zm6.5 0c0-7.1 5.8-12.9 12.9-12.9s12.9 5.8 12.9 12.9v32.3c0 7.1-5.8 12.9-12.9 12.9s-12.9-5.8-12.9-12.9V77.6z" fill="#e01e5a"></path><path d="M45.2 25.8c-7.1 0-12.9-5.8-12.9-12.9S38.1 0 45.2 0s12.9 5.8 12.9 12.9v12.9H45.2zm0 6.5c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9H12.9C5.8 58.1 0 52.3 0 45.2s5.8-12.9 12.9-12.9h32.3z" fill="#36c5f0"></path><path d="M97 45.2c0-7.1 5.8-12.9 12.9-12.9s12.9 5.8 12.9 12.9-5.8 12.9-12.9 12.9H97V45.2zm-6.5 0c0 7.1-5.8 12.9-12.9 12.9s-12.9-5.8-12.9-12.9V12.9C64.7 5.8 70.5 0 77.6 0s12.9 5.8 12.9 12.9v32.3z" fill="#2eb67d"></path><path d="M77.6 97c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9-12.9-5.8-12.9-12.9V97h12.9zm0-6.5c-7.1 0-12.9-5.8-12.9-12.9s5.8-12.9 12.9-12.9h32.3c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9H77.6z" fill="#ecb22e"></path></svg>Add to Slack</div>
       </div>
     </b-col>
     </b-row>
     <div style="max-width:50rem;margin:auto;">
       <b-row style="margin-top:2rem;">
       <b-col class="install-text">
          <span>
            Start videocafe.live calls from Slack with
            the</span>
          <span style="color:#a02020;">
            /vcafe
          </span>
          <span>command.</span>
       </b-col>
       </b-row>
       <b-row style="margin: auto 0.5rem; text-align:center;">
       <b-col>
         <img style="max-width:100%;border: solid 1px black;border-radius:5px;"
           src="../../public/images/Landing_Page_step_01.jpg">
         </img>
       </b-col>
       </b-row>

       <b-row style="margin-top:2rem;">
       <b-col class="install-text" style="min-width:20rem">
           Anyone in the channel can click on the Get Link button when they are ready.  A Join button will appear.
       </b-col>
       </b-row>
       <b-row style="margin: auto 0.5rem; text-align:center;">
       <b-col>
         <img style="max-width:100%;border: solid 1px black;border-radius:5px;"
           src="../../public/images/Landing_Page_step_02.jpg">
         </img>
       </b-col>
       </b-row>

       <b-row style="margin-top:2rem;">
       <b-col class="install-text" style="min-width:20rem">
          Click on the Join button to open the VideoCafe room in a new browser tab.
       </b-col>
       </b-row>
       <b-row style="margin: auto 0.5rem; text-align:center;">
       <b-col>
         <img style="max-width:100%;border: solid 1px black;border-radius:5px;"
           src="../../public/images/Landing_Page_step_03.jpg">
         </img>
       </b-col>
       </b-row>

       <b-row style="margin-top:2rem;">
       <b-col class="install-text" style="min-width:20rem">
          Slack now will ask your permission to sign in to VideoCafe with your Slack credentials.  Click "Accept and Continue" to proceed.
       </b-col>
       </b-row>
       <b-row style="margin: auto 0.5rem; text-align:center;">
       <b-col>
         <img style="max-width:100%;border: solid 1px black;border-radius:5px;"
           src="../../public/images/Landing_Page_step_03b.jpg">
         </img>
       </b-col>
       </b-row>

       <b-row style="margin-top:2rem;">
       <b-col class="install-text" style="min-width:20rem">
          Start streaming in the room.  Other persons in your Slack channel can join you.
       </b-col>
       </b-row>
       <b-row style="margin: auto 0.5rem; text-align:center;">
       <b-col>
         <img style="max-width:100%;border: solid 1px black;border-radius:5px;"
           src="../../public/images/Landing_Page_step_04.jpg">
         </img>
       </b-col>
       </b-row>
     </div>
    </div>

    <div class="result_card"
       v-if="success !== null">

     <b-row style="justify-content:center;">
     <b-col style="max-width:35rem;">
       <div style="text-align:center;margin-bottom:2rem;">
         <img style="height:fit-context;width:60%;"
           src="../../public/images/logo2.svg">
         </img>
       </div>
     </b-col>
     </b-row>

     <b-row v-if="success" style="justify-content:center;">
     <b-col style="">
       <div style="max-width:60%;margin:auto;">
         <div class="install-text"
           style="margin-top:1rem;text-align:center;">
           Congratulations! VideoCafe has been installed to your Slack Workspace.
         </div>
         <div class="install-text" style="margin-top:1rem;">
           <span> You can now use the </span>
           <span style="color:#a02020;font-weight:bold;font-size:1rem;">/vcafe</span>
           <span> command to get a link to and join VideoCafe sessions. </span>
         </div>
       </div>
     </b-col>
     </b-row>

     <b-row v-if="success" style="margin: auto 0.5rem; text-align:center;">
     <b-col>
       <img style="max-width:100%;border: solid 1px black;border-radius:5px;"
         src="../../public/images/Congrats_Page_step_01.jpg">
       </img>
     </b-col>
     </b-row>

     <b-row v-if="!success" style="justify-content:center;">
     <b-col style="max-width:50rem;">
       <div 
         style="font-size: 1.2rem; font-style:bold; color: red;">
         {{ result }}
       </div>
     </b-col>
     </b-row>

   </div>
  </div>
</template>

<script>
import { sync } from "vuex-pathify";
import store from "../store";

export default {
  name: "slackinstall",
  data() {
    return {
      account: "",
      result: "-",
      success: null,
      account_error: false,
    }
  },
  components: {
  },
  created() {
  },
  computed: {
  },
  mounted() {
    let vue = this;
    let cfg = vue.$router.currentRoute.params.cfg;
    if (cfg) {
      let j = to_json(decodeURIComponent(cfg));
      if (j) {
         if (j.status == 200) {
           vue.success = true;
         } else {
           vue.success = false;
           vue.result = "The installation failed:"+j.msg;
         }
      }
    }
  },
  methods: {
    install: function() {
      let vue = this;
      let url, acc;
      vue.account_error = false;
      if (vx.staging) {
         url = "https://app.staging.vuemix.com/mm/loginredirect.html?action=slack_install";
         acc = "uploadvue-app.staging";
      } else {
         url = "https://mapp.vuemix.com/mm/loginredirect.html?action=slack_install";
         acc = "vcafe-app";
      }
      if (vue.account) {
        acc = ""+vue.account;
      }
      url += "&acc="+acc;
      url += "&resume=" + encodeURIComponent("/mm/#/slackinstall/[RSP]");
      if (vue.account) {
        let chk = vx.rq_endpoint+"/adm/account/kp/"+vue.account+"/cfg";
        issue_http({nocred:true, type:"GET", url: chk, done: function(s,r) {
           if (s != 200) {
              vue.account_error = true;
              return;
           }
           window.location.href = url;
        }});
      } else {
        window.location.href = url;
      }
    }
  },
};
</script>

<style lang="scss" scoped>

.install_card {
}

.install-text {
  line-height:1.1rem;
  font-size:1rem;
  font-weight:bold;
}

.slack_btn {
  align-items:center;
  color:#fff;
  background-color:#4A154B;
  border:0;
  border-radius:4px;
  display:inline-flex;
  font-family:Lato, sans-serif;
  font-size:16px;
  font-weight:600;
  height:48px;
  justify-content:center;
  text-decoration:none;
  width:236px;
  cursor:pointer;
}
.slack_btn:hover {
  background-color: #5A255B;
}

@media screen and (max-width:600px) and (orientation:portrait) {
 .vxwport {
   top: 0px !important;
 }
 .install_left {
   flex: 1 1 auto;  
 }
 .install_right {
   display: none;
 }
}

.result_card {
  margin: 2rem;
  text-align: center;
}
</style>
